import React, { useEffect, useState } from 'react'
import { PLL_LINKS } from '../../../../Config/config'
import { AnnouncementCallout } from '../../../../Components/Callout/AnnouncementCallout'
import {
  HOMECOMING_BUY_LINKS,
  HOMECOMING_LIVE_TIMES,
} from '../../../../Constants/tickets'

type HomecomingPassCalloutProps = {
  market?: string
}

export const HomecomingPassCallout: React.FC<
  React.PropsWithChildren<HomecomingPassCalloutProps>
> = ({ market }) => {
  const [showCallout, setShowCallout] = useState<boolean>(false)
  const [homecomingLink, setHomecomingLink] = useState<string | null>(null)

  useEffect(() => {
    const isAMarket =
      market && Object.prototype.hasOwnProperty.call(HOMECOMING_BUY_LINKS, market)
        ? true
        : false
    const homecomingLink = getHomecomingBuyLink(isAMarket)
    setHomecomingLink(homecomingLink)

    isAMarket ? setShowCallout(true) : setShowCallout(false)
  }, [market])

  const getHomecomingBuyLink = (isMarket: boolean) => {
    if (!market) return null
    const hasUnlockTime = HOMECOMING_LIVE_TIMES[market]
    const now = new Date().getTime() / 1000
    if (hasUnlockTime && now < HOMECOMING_LIVE_TIMES[market]) return null
    if (isMarket && hasUnlockTime && HOMECOMING_BUY_LINKS[market] !== '')
      return HOMECOMING_BUY_LINKS[market]
    return null
  }

  return (
    <>
      {showCallout && (
        <AnnouncementCallout
          title={`Secure your Homecoming Pass, powered by Ticketmaster`}
          buttonText={homecomingLink ? `Get Pass` : `Place Deposit`}
          buttonLink={homecomingLink ? homecomingLink : PLL_LINKS.homecomingPassClub}
          description={`Premier Lacrosse League's version of Season Tickets`}
        />
      )}
    </>
  )
}
